"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetLinkLocaleSlug = void 0;
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const react_1 = require("react");
const useCurrentLocale_1 = require("./useCurrentLocale");
const useLanguages_1 = require("./useLanguages");
/**
 * Determines correct locale slug for the link (trying to shorten the locale code if possible).
 * E.g. if newsroom has a single locale for Dutch (`nl_BE`), it will be shortened to `nl`.
 * If there are more than one locale with the same language part, a full locale code will be used instead.
 * `false` means that a default locale should be used (no locale in URL required).
 */
function getLinkLocaleSlug(languages, locale) {
    const shortestLocaleCode = (0, theme_kit_core_1.getShortestLocaleCode)(languages, locale);
    // When navigating to default language, we don't append the locale to the URL.
    if (!shortestLocaleCode) {
        return shortestLocaleCode;
    }
    return theme_kit_core_1.LocaleObject.fromAnyCode(shortestLocaleCode).toUrlSlug();
}
function useGetLinkLocaleSlug() {
    const currentLocale = (0, useCurrentLocale_1.useCurrentLocale)();
    const languages = (0, useLanguages_1.useLanguages)();
    // The `locale` parameter is mainly used for Language Dropdown
    return (0, react_1.useCallback)((locale) => getLinkLocaleSlug(languages, locale || currentLocale), [languages, currentLocale]);
}
exports.useGetLinkLocaleSlug = useGetLinkLocaleSlug;
//# sourceMappingURL=useGetLinkLocaleSlug.js.map